<template>
  <div class="p-3">
    <el-table
      :data="sourceFields"
      style="width: 100%"
      v-loading="mappingConfigLoading"
      element-loading-text="Loading Fields"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="applicationFieldLabel" label="Entity Fields">
        <template #default="{ row }">
          <span>
            {{ row.applicationFieldLabel }}
            <span v-if="row.required" style="color: red">*</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="`${getApplication().label} Fields`">
        <template #default="{ row }">
          <el-select
            v-model="params.mappingConfig[row.applicationFieldKey]"
            placeholder="Select field"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="(field, index) in targetFields"
              :key="index"
              :label="field.label"
              :value="field.key"
            />
          </el-select>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    sourceFields: {
      type: Array,
      required: true,
    },
    targetFields: {
      type: Array,
      required: true,
    },
    applications: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    mappingConfigLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getApplication() {
      return this.applications.find(
        (app) => app.key === this.params.application
      );
    },
  },
};
</script>
